var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"File Explorer","border-variant":"warning"}},[_c('b-card-text',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_vm._v(" Here you will be able to edit and upload custom files to the ESP ")])],1),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('iframe',{attrs:{"width":"100%","height":"700px","src":"/edit"}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }